export const uk = {
    'and-more-links': 'И ещё {moreLinksCount}',
    'filter-by-banner': 'Показать логи по объявлению №{banner}',
    'filter-by-cid': 'Показать логи по кампании №{cid}',
    'filter-by-group': 'Показать логи по группе №{group}',
    'open-banner': 'Перейти к объявлению №{banner}',
    'open-campaign': 'Перейти к кампании №{cid}',
    'open-group': 'Перейти к группе №{group}'
};
